const Getters = {
  getEcGoodsListFromState: (state) => {
    return state.ecGoodsList
  },
  getEcReceiveorderListFromState: (state) => {
    return state.ecReceiveOrderList
  },
  getNextengineCooperateConfigFromState: (state) => {
    return state.nextengineCooperateConfigData
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
